import React, { useState } from 'react';
import SimpleBookingForm from './components/SimpleBookingForm';
import EstimationPage from './components/EstimationPage';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CallButton from './components/CallButton';
import WhyChooseUs from './components/WhyChooseUs';
import ImportantNotes from './components/ImportantNotes';
import PopularDestinations from './components/PopularDestinations';
import LocalPackageTrips from './components/LocalPackageTrips';
import TariffRates from './components/TariffRates';
import VehicleTariffCards from './components/VehicleTariffCards';
import Testimonials from './components/Testimonials';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('booking');
  const [bookingData, setBookingData] = useState(null);

  const handleEstimate = (data) => {
    setBookingData(data);
    setCurrentPage('estimation');
  };

  const handleNewBooking = () => {
    setBookingData(null);
    setCurrentPage('booking');
  };

  const handleBackToBooking = () => {
    setCurrentPage('booking');
    // Keep the booking data so form can be pre-filled
  };

  const handleModifyBooking = () => {
    setCurrentPage('booking');
    // Keep the booking data so form can be pre-filled
  };

  return (
    <div className="App">
      <Header />
      <main className="main-content">
        {currentPage === 'booking' && (
          <>
            <SimpleBookingForm 
              onEstimate={handleEstimate} 
              initialData={bookingData}
            />
            <VehicleTariffCards />
            <PopularDestinations />
            <TariffRates />
            <LocalPackageTrips />
            <ImportantNotes />
            <WhyChooseUs />
            <Testimonials />
          </>
        )}
        {currentPage === 'estimation' && bookingData && (
          <EstimationPage 
            bookingData={bookingData}
            onBack={handleBackToBooking}
            onModify={handleModifyBooking}
            onNewBooking={handleNewBooking}
          />
        )}
      </main>
      <Footer />
      <WhatsAppButton />
      <CallButton />
    </div>
  );
}

export default App;